import { Routes, Route, Navigate } from "react-router-dom";
import AdminSidebar from "./components/AdminSidebar.jsx";
import { PAGE_COMPONENTS, PAGE_ROUTES } from "./panelAdminRouter.js";

function PanelUser() {
  return (
    <div dir="rtl" className="panel-user">
      <Routes>
        {/* Sidebar به عنوان Layout: خودش رندر میشه و صفحه‌ی فعال داخل Outlet قرار می‌گیره */}
        <Route element={<AdminSidebar />}>
          {/* مسیر پیش‌فرض وقتی کاربر وارد /panel میشه */}
          <Route index element={<Navigate to="AdminDashboard" replace />} />

          {PAGE_ROUTES.map(({ id, Component, children }) => (
            <Route key={id} path={id} element={<Component />} />
          ))}

          {/*
                  زیرصفحه‌ها به‌صورت مسیر مستقل (نه تودرتو با Outlet) رندر میشن:
                  وقتی کاربر مثلاً میره /panel/manage-shops/12/pages، به‌جای
                  ManageShops کلاً EditShopPages نمایش داده میشه.
                */}
          {PAGE_ROUTES.flatMap(({ id, children }) =>
            (children || []).map((child) => (
              <Route
                key={`${id}/${child.path}`}
                path={`${id}/${child.path}`}
                element={<child.Component />}
              />
            )),
          )}
        </Route>
      </Routes>
    </div>
  );
}

export default PanelUser;
